<div class="table-row">
	@let r = getDataRow();
	@if (showDate()) {
		<div>{{ row().date | date: 'HH:mm' }}</div>
	}
	<div class="font-decimaBold">{{ CaffTypeDict[r.type].name }}</div>
	<div class="ml-auto">{{ r.mg }}mg</div>
</div>